import { Settings } from 'react-slick'
import styled from 'styled-components'
import NewIcon from 'assets/img/new.png'

export const viewPageSliderSettings: Settings = {
	dots: false,
	infinite: true,
	arrows: false,
	speed: 300,
	centerMode: true,
	slidesToScroll: 2,
	slidesToShow: 3,
	autoplay: true,
	autoplaySpeed: 5000,
}

export const OtherColorSlider = styled.div`
	position: absolute;
	bottom: 0;
	right: 130px;
	// width: 680px;
	left: 450px;
	height: 320px;
	padding-top: 75px;
	.indexImage {
		position: absolute;
		bottom: 42px;
		right: 20px;
		display: block;
	}
	.otherColor {
		position: absolute;
		bottom: 268px;
		// right: -40px;
		left: 300px;
	}
	.sex {
		width: 144px;
		line-height: 46px;
		background: #001e62;
		color: #fff;
		font-size: 20px;
		font-family: 'asics bold';
		text-align: center;
		border-radius: 100px;
		margin-right: 20px;
	}
	.diffItems {
		.diffRow {
			button {
				outline: 0;
				border: 0;
				background: transparent;
				display: block;
				margin: 0 auto;
			}
			ul {
				list-style: none;
				padding: 0;
				margin: 0;
				li {
				}
			}
		}
	}
`

export const NewIconImg = styled.img`
	position: absolute;
	top: 5px;
	left: 5px;
	width: auto;
	height: 14px;
	background: url(${NewIcon}) no-repeat center;
`
